const NotificationsWithIndicator = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  if (width === '16' && height === '16') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={`${hidden}`}
        role={role ? role : hidden ? 'graphics-document' : 'img'}
      >
        {!hidden && <title>{title}</title>}
        <path
          d="M6.88898 13.6672C6.95954 13.9076 7.10608 14.1187 7.30663 14.2688C7.50719 14.419 7.75099 14.5001 8.00152 14.5001C8.25205 14.5001 8.49585 14.419 8.6964 14.2688C8.89696 14.1187 9.04349 13.9076 9.11406 13.6672"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M8.00018 3.25005V2"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M8.00019 3.25012C9.1053 3.25012 10.1651 3.68913 10.9466 4.47056C11.728 5.25199 12.167 6.31183 12.167 7.41694C12.167 11.3315 13.0004 12.0005 13.0004 12.0005H3C3 12.0005 3.83336 10.936 3.83336 7.41694C3.83336 6.31183 4.27237 5.25199 5.0538 4.47056C5.83523 3.68913 6.89508 3.25012 8.00019 3.25012V3.25012Z"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <circle cx="11.8" cy="6.11104" r="2.3" fill="#BA1E50" stroke="white" />
      </svg>
    );
  } else {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        stroke="#000000"
        aria-hidden={`${hidden}`}
        role={role ? role : hidden ? 'graphics-document' : 'img'}
      >
        {!hidden && <title>{title}</title>}
        <path
          d="M10.2221 20.6666C10.335 21.0512 10.5695 21.3889 10.8903 21.6292C11.2112 21.8694 11.6013 21.9992 12.0021 21.9992C12.4029 21.9992 12.793 21.8694 13.1139 21.6292C13.4348 21.3889 13.6692 21.0512 13.7821 20.6666"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M12 4V2"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <path
          d="M12 4C13.7681 4 15.4638 4.70238 16.714 5.95262C17.9643 7.20286 18.6667 8.89856 18.6667 10.6667C18.6667 16.9298 20 18 20 18H4C4 18 5.33333 16.2969 5.33333 10.6667C5.33333 8.89856 6.03571 7.20286 7.28595 5.95262C8.5362 4.70238 10.2319 4 12 4V4Z"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="currentColor"
        />
        <circle cx="18" cy="8" r="4" fill="#BA1E50" stroke="white" strokeWidth="2" />
      </svg>
    );
  }
};

export default NotificationsWithIndicator;
